// DeleteConfirmModal.js
import React from 'react';
import './DeleteConfirmModal.css';

const DeleteConfirmModal = ({
  currentLanguage,
  getLocalizedText,
  onConfirm,
  onCancel,
  isSuccess = false,        
  successMessage = null   
}) => {
  const t = (ar, en) => getLocalizedText(ar, en);

  if (isSuccess) {
    return (
      <div className="delete-confirm-overlay" onClick={(e) => e.stopPropagation()}>
        <div className={`delete-confirm-modal ${currentLanguage === 'ar' ? 'ar' : 'en'}`}>
          <h3 className="delete-confirm-title success-title">
            {t('تم حذف الإعلان بنجاح', 'Ad deleted successfully')}
          </h3>
        

          <div className="delete-confirm-buttons">
            <button className="delete-confirm-btn close" onClick={onCancel}>
              {t('إغلاق', 'Close')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // الحالة العادية: التأكيد قبل الحذف
  return (
    <div className="delete-confirm-overlay" onClick={(e) => e.stopPropagation()}>
      <div className={`delete-confirm-modal ${currentLanguage === 'ar' ? 'ar' : 'en'}`}>
        <h3 className="delete-confirm-title">
          {t('هل أنت متأكد؟', 'Are you sure?')}
        </h3>
        <p className="delete-confirm-message">
          {t('هل تريد حقًا حذف هذا الإعلان؟', 'Do you really want to delete this ad?')}
        </p>

        <div className="delete-confirm-buttons">
          <button className="delete-confirm-btn cancel" onClick={onCancel}>
            {t('إلغاء', 'Cancel')}
          </button>
          <button className="delete-confirm-btn confirm" onClick={onConfirm}>
            {t('نعم، حذف', 'Yes, Delete')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;